<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Kategori Düzenle</h4>
              <p class="card-category">Kategoriyi düzenlemek için gerekli bilgileri giriniz.</p>
            </template>


            <form class="m-5">
              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Kategori Adı" placeholder="Kategori Adı" v-model="category.name">
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Açıklama" placeholder="Açıklama" v-model="category.description">
                  </base-input>
                </div>
              </div>


              <label>Üst Kategori Seçimi</label>
              <div class="row">
                <div class="col-md-4">
                  <select class="form-control" v-model="category.parentCategory">
                    <option value="">Üst Kategori Seçiniz</option>
                    <option v-for="category in categories" :key="category._id" :value="category._id">
                      {{ category.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row pt-5">
                <div class="col-md-4">
                  <label>Kategori Aktif Mi?</label>
                  <base-checkbox type="text" label="Host" placeholder="Host" v-model="category.isActive">
                  </base-checkbox>
                </div>
              </div>





              <div class="text-center">
                <button type="submit" class="btn btn-info btn-fill float-right" @click="updateCategory()">
                  Güncelle
                </button>
              </div>
              <div class="clearfix"></div>
            </form>

          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";
export default {
  components: {
    Card
  },
  data() {
    return {
      id: null,
      category: {},
      categories: []
    }
  },
  mounted() {
    this.id = window.location.href.split('/').at(-1);
    this.getCategories();
    this.getCategory();
  },
  methods: {
    updateCategory() {
      CollectionService.updateCollectionItem('category', this.id, this.category).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "Kategori Güncellendi")
          this.$router.push(`/admin/categories`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    getCategory() {

      CollectionService.getCollectionItemWithId('category', this.id).then((res) => {
        if (res.success == true) {
          this.category = res.category;
        } else {
          console.log('error');
        }
      })
    },
    getCategories() {
      CollectionService.getCollection('category').then((res) => {
        if (res.success == true) {
          this.categories = res.categories.filter(category => category._id != this.id);
        } else {
          console.log('error');
        }
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    }
  }
}
</script>
<style></style>